import React, { useState } from "react";
import { T } from "../../app/tokens.js";
import { ChevronRight, Edit2, Plus } from "lucide-react";
import { OkrProgressBar } from "./OkrProgressBar.jsx";
import { OkrStatusBadge } from "./OkrStatusBadge.jsx";
import { OkrInitiative } from "./OkrInitiative.jsx";

export function OkrKeyResult({
  keyResult,
  initiatives = [],
  canEdit = false,
  onEditKR,
  onAddInitiative,
  onEditInitiative,
  onViewUpdates
}) {
  const [expanded, setExpanded] = useState(false);
  const [hover, setHover] = useState(false);

  const {
    id,
    title,
    quarter,
    status,
    targetType,
    targetValue,
    rollupPercent
  } = keyResult;

  const hasInitiatives = initiatives.length > 0;

  return (
    <div style={{ background: T.white, borderBottom: `1px solid ${T.border}` }}>
      <div
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          display: "flex", alignItems: "center", gap: 16,
          padding: "12px 16px 12px 32px",
          background: hover ? T.hoverBg : "transparent",
          transition: "background 0.2s ease"
        }}
      >
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          style={{
            background: "transparent", border: "none", cursor: "pointer",
            padding: 4, display: "grid", placeItems: "center",
            color: hasInitiatives ? T.dark : T.line,
            opacity: hasInitiatives ? 1 : 0,
            pointerEvents: hasInitiatives ? "auto" : "none",
            transform: expanded ? "rotate(90deg)" : "none",
            transition: "transform 0.2s ease"
          }}
        >
          <ChevronRight size={16} />
        </button>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: T.fsXxs, fontWeight: T.fwBold, color: T.mid, background: T.tile, padding: "2px 6px", borderRadius: 4 }}>{quarter}</span>
            <span style={{ fontSize: T.fsBase, fontWeight: T.fwSemibold, color: T.dark, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {title}
            </span>
          </div>
        </div>

        <div style={{ width: 120, flexShrink: 0 }}>
          <div style={{ fontSize: T.fsXs, color: T.mid, marginBottom: 2 }}>Target</div>
          <div style={{ fontSize: T.fsSm, fontWeight: T.fwSemibold, color: T.dark }}>
            {targetType === "percent" ? `${targetValue}%` : targetType === "currency" ? `$${Number(targetValue).toLocaleString()}` : targetType === "binary" ? "Yes" : targetValue}
          </div>
        </div>

        <div style={{ width: 100, flexShrink: 0 }}>
          <OkrStatusBadge status={status} />
        </div>

        <div style={{ width: 120, flexShrink: 0 }}>
          <OkrProgressBar percent={rollupPercent} size="sm" color={T.blue} />
        </div>

        {canEdit && (
          <div style={{ width: 64, flexShrink: 0, display: "flex", justifyContent: "flex-end", gap: 4 }}>
            <button
              type="button"
              onClick={() => onAddInitiative(keyResult)}
              style={{
                background: "transparent", border: "none", cursor: "pointer",
                color: T.mid, padding: 4, borderRadius: 4,
                opacity: hover ? 1 : 0, transition: "opacity 0.2s ease"
              }}
              title="Add Initiative"
            >
              <Plus size={14} />
            </button>
            <button
              type="button"
              onClick={() => onEditKR(keyResult)}
              style={{
                background: "transparent", border: "none", cursor: "pointer",
                color: T.blue, padding: 4, borderRadius: 4,
                opacity: hover ? 1 : 0, transition: "opacity 0.2s ease"
              }}
              title="Edit Key Result"
            >
              <Edit2 size={14} />
            </button>
          </div>
        )}
      </div>

      {expanded && hasInitiatives && (
        <div style={{ background: T.lightGray, borderTop: `1px solid ${T.border}` }}>
          {initiatives.map(ini => (
            <OkrInitiative
              key={ini.id}
              initiative={ini}
              canEdit={canEdit}
              onEdit={onEditInitiative}
              onUpdates={onViewUpdates}
            />
          ))}
        </div>
      )}
    </div>
  );
}
